import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationTriangle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import { StyledAvPill } from '../../constants/ticketlist.styled';
import { isErrorResult, isRejectResult } from '../../constants/ticketlist.utils';

interface IAvDecisionBadgeProps {
    result?: string;
    'data-testid'?: string;
}

export const AvDecisionBadge = ({ result, ...rest }: IAvDecisionBadgeProps) => {
    const intl = useIntl();
    const error = isErrorResult(result);
    const reject = !error && isRejectResult(result);
    const labelId = error
        ? 'ticket.autoVerification.decision.error'
        : reject
            ? 'ticket.autoVerification.decision.reject'
            : 'ticket.autoVerification.decision.accept';
    const icon = error ? faExclamationTriangle : reject ? faTimesCircle : faCheckCircle;

    return (
        <StyledAvPill $reject={reject} $error={error} data-testid={rest['data-testid'] || 'av-decision-badge'}>
            <FontAwesomeIcon icon={icon} />
            <span>{intl.formatMessage({ id: labelId })}</span>
        </StyledAvPill>
    );
};
